var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservePattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 652,
    viewBox: "0 0 1020 652",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 97L8 272.95L98.0499 356.249V603.074L149.86 651H396.264L474.334 542.118H957",
    stroke: "url(#paint0_linear_67_654)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.52 535.355C1014.46 535.355 1019 539.46 1019 544.216C1019 548.972 1014.46 553.076 1008.52 553.076C1002.58 553.076 998.038 548.972 998.038 544.216C998.038 539.46 1002.58 535.355 1008.52 535.355Z",
    fill: "#00FFFB",
    stroke: "url(#paint1_linear_67_654)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4811 90.0792C17.4178 90.0792 21.9622 94.1835 21.9622 98.9397C21.9622 103.696 17.4178 107.8 11.4811 107.8C5.54437 107.8 1 103.696 1 98.9397C1 94.1835 5.54436 90.0792 11.4811 90.0792Z",
    fill: "#00FFFB",
    stroke: "url(#paint2_linear_67_654)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M316.903 33.3411C322.84 33.3411 327.385 37.4455 327.385 42.2017C327.385 46.9579 322.84 51.0622 316.903 51.0622C310.967 51.0622 306.422 46.9579 306.422 42.2017C306.422 37.4455 310.967 33.3411 316.903 33.3411Z",
    fill: "#00FFFB",
    stroke: "url(#paint3_linear_67_654)",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6654 219.652V34.4883H288.502L350.479 87.7274H608.051L660.457 42.7286L805.302 42.7286",
    stroke: "url(#paint4_linear_67_654)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0646 590.726L59.5523 604.002V616.191L39.0646 602.915V590.726ZM59.5523 585.586L39.0646 572.31V560.121L59.5523 573.397V585.586ZM59.5523 554.98L39.0646 541.704V529.515L59.5523 542.791V554.98ZM59.5523 524.375L39.0646 511.099V498.91L59.5523 512.186V524.375ZM59.5523 493.769L39.0646 480.493V468.304L59.5523 481.58V493.769ZM59.5523 463.164L39.0646 449.888V437.699L59.5523 450.975V463.164ZM59.5523 432.558L39.0646 419.282V407.093L59.5523 420.369V432.558Z",
    fill: "#73FAFD",
    stroke: "url(#paint5_linear_67_654)",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M988.293 544.216V46.3071L935.54 1.00014H529.593L481.62 42.2018H309.763",
    stroke: "url(#paint6_linear_67_654)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M848.668 578.052V596.799H870.496V578.052H848.668Z",
    stroke: "url(#paint7_linear_67_654)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M908.754 595.799H888.926V579.052H908.754V595.799Z",
    fill: "#00FFFB",
    stroke: "url(#paint8_linear_67_654)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M927.196 578.052V596.799H949.024V578.052H927.196Z",
    stroke: "url(#paint9_linear_67_654)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_654",
    x1: 8,
    y1: 374,
    x2: 957,
    y2: 374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_67_654",
    x1: 997.038,
    y1: 544.216,
    x2: 1020,
    y2: 544.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_67_654",
    x1: 0,
    y1: 98.9397,
    x2: 22.9622,
    y2: 98.9397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_67_654",
    x1: 305.422,
    y1: 42.2017,
    x2: 328.385,
    y2: 42.2017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_67_654",
    x1: 99.6654,
    y1: 127.07,
    x2: 805.302,
    y2: 127.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_67_654",
    x1: 38.0646,
    y1: 511.642,
    x2: 60.5523,
    y2: 511.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_67_654",
    x1: 309.763,
    y1: 272.608,
    x2: 988.293,
    y2: 272.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_67_654",
    x1: 848.668,
    y1: 587.425,
    x2: 870.496,
    y2: 587.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_67_654",
    x1: 887.926,
    y1: 587.425,
    x2: 909.754,
    y2: 587.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_67_654",
    x1: 927.196,
    y1: 587.425,
    x2: 949.024,
    y2: 587.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservePattern);
export default __webpack_public_path__ + "static/media/Reserve-pattern.ebc64c5c80b3cbaa3081a4bfcc3dcbf2.svg";
export { ForwardRef as ReactComponent };